import { Icon } from "../icon";
import "./pagination.css";

interface PaginationProps {
    page: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

export default function Pagination({
    page,
    totalPages,
    onPageChange
}: PaginationProps) {

    return (
        <div className="pagination">
            <button
                disabled={page === 1}
                onClick={() => onPageChange(page - 1)}
            >
                <Icon className="pagination-icon" name="chevron-left" size="small"/>
            </button>
            {Array.from({ length: totalPages }).map((_, i) => {
                const p = i + 1;
                return (
                    <button
                        key={p}
                        className={page === p ? "active" : ""}
                        onClick={() => onPageChange(p)}
                    >
                        {p}
                    </button>

                );
            })}
            <button
                disabled={page === totalPages}
                onClick={() => onPageChange(page + 1)}
            >
                <Icon className="pagination-icon" name="chevron-right" size="small"/>
            </button>
        </div>
    );
}